
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TenantModel } from 'src/app/core/models/global/clients/tenant-model';
import { AssetModel } from 'src/app/core/models/tenant/location/asset-model';
import { AppComponentBase } from 'src/app/core/utils/base-components/app-component-base';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';

@Component({
  templateUrl: './session-from-email.component.html',
  standalone: false
})
export class SessionFromEmailComponent extends AppComponentBase implements OnInit, OnDestroy {

    public redirectUrl: string = "https://app.emissions.ai";

    public currentTenant?: TenantModel;
    public assets?: AssetModel[];

    constructor(private router: Router, private analyticsService: AnalyticsService) {
        super();

        let sessionSubscription = this.appOktaSessionService.sessionState$().subscribe(s => {
            this.sessionInfo = s;
            this.loadPageData();
            // Set if the session is impersonated
            this.isImpersonatedSession = this.sessionInfo.originalUserSessionState !== undefined;
        });
        this.sessionStateSubscription.add(sessionSubscription);
    }

    public override ngOnInit(): void {
        super.ngOnInit();

        this.loadPageData();
    }

    public override loadPageData(): void {
        this.logDebug(this.loadPageData.name, 'Loading session from email page data');
        this.loggingEmailReferredLogin();
        this.router.navigate(['/']);
    }

    /**
     * Logging email referred login to analytics API.
     */
    public loggingEmailReferredLogin(): void {
        this.logDebug(this.loggingEmailReferredLogin.name, 'Logging email referred login');
        this.analyticsService.startAnalyticsSession("email");
    }

    public override ngOnDestroy(): void {
        this.logDebug(this.ngOnDestroy.name, 'Redirect OnDestroy');
        // Unsubscribe from all subscriptions
        this.sessionStateSubscription.unsubscribe();
        this.pageSubscriptions.unsubscribe();

        super.ngOnDestroy();
    }
}

